export const expensesTableComponent = {
	addExpensesButton: "Lançar Despesas",
};
